import apiClient from './authService';

export const settingsService = {
  /** Returns the full settings definition manifest (drives the UI). */
  getDefinition: () =>
    apiClient.get('/api/settings/definition').then(r => r.data),

  /** Returns merged settings (defaults + org overrides). */
  get: () =>
    apiClient.get('/api/settings').then(r => r.data),

  /** Saves partial settings overrides. body = { key: value, ... } */
  save: (body) =>
    apiClient.put('/api/settings', body).then(r => r.data),
};
